import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { CommandDialog, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem } from "@/components/ui/command";
import { Building2, Users, CheckSquare } from "lucide-react";

export function GlobalSearch({ open, onOpenChange }) {
  const [results, setResults] = useState({ organizations: [], people: [], tasks: [] });
  const navigate = useNavigate();
  const onSearch = async (q) => {
    if (!q || q.length < 2) { setResults({ organizations: [], people: [], tasks: [] }); return; }
    try { const { data } = await api.get("/search", { params: { q } }); setResults(data); } catch (e) {}
  };
  const go = (path) => { onOpenChange(false); navigate(path); };
  return (
    <CommandDialog open={open} onOpenChange={onOpenChange}>
      <CommandInput placeholder="Search organizations, people, tasks…" onValueChange={onSearch} data-testid="global-search-input" />
      <CommandList>
        <CommandEmpty>Type at least 2 characters…</CommandEmpty>
        {results.organizations.length > 0 && (
          <CommandGroup heading="Organizations">
            {results.organizations.map((o) => (
              <CommandItem key={o.id} onSelect={() => go(`/crm/organizations/${o.id}`)}><Building2 className="w-4 h-4 mr-2" />{o.name}</CommandItem>
            ))}
          </CommandGroup>
        )}
        {results.people.length > 0 && (
          <CommandGroup heading="People">
            {results.people.map((p) => (
              <CommandItem key={p.id} onSelect={() => go(`/crm/people`)}><Users className="w-4 h-4 mr-2" />{p.first_name} {p.last_name}</CommandItem>
            ))}
          </CommandGroup>
        )}
        {results.tasks.length > 0 && (
          <CommandGroup heading="Tasks">
            {results.tasks.map((t) => (
              <CommandItem key={t.id} onSelect={() => go(`/work/items/${t.id}`)}><CheckSquare className="w-4 h-4 mr-2" />{t.title}</CommandItem>
            ))}
          </CommandGroup>
        )}
      </CommandList>
    </CommandDialog>
  );
}
